import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRightDown14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.25 10.1894L11.25 4.99997H12.75L12.75 12.75H4.99999V11.25H10.1893L1.4696 2.5303L2.53026 1.46964L11.25 10.1894Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRightDown14.displayName = 'ArrowRightDown14';
export default ArrowRightDown14;
